import React, { PropsWithChildren } from "react";

export class HeaderLayout extends React.Component<PropsWithChildren> {
  render() {
    return this.props.children;
  }
}
